<template>
  <div>
    <rotaion
      :height="height"
      :route="this.$route.path"
      arrow="never"
      position="none"
    ></rotaion>
    <div class="center-content">
      <div class="center">
        <div class="cooperation">
          <h2>商务合作</h2>
          <p>产品发行：&nbsp;小游戏引入</p>
          <p>产品定制：&nbsp;寻优秀研发定制和寻找游戏发行定制产品</p>
          <p>资源整合：&nbsp;小游戏平台买量卖量</p>
          <p>联系人：&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;饭饭</p>
          <p class="contact">
            联系方式：&nbsp;<img
              style="width: 100px; height: 100px"
              src="../common/imgs/code.png"
            />
          </p>
          <p>
            联系电话：&nbsp;0592-5991505
          </p>
          <p>
            联系手机：&nbsp;18016550661
          </p>
        </div>
        <div class="posization">
          <h2>我们的位置</h2>
          <Map></Map>
          <p class="place" style="margin-top: 10px">
            地址：福建省厦门市思明区软件园二期望海路65号之二808
          </p>
        </div>
      </div>
      <bottom></bottom>
    </div>
  </div>
</template>

<script>
import Map from "../components/Map/Map.vue";
import rotaion from "./components/rotation";
import bottom from "./components/bottom";
export default {
  data() {
    return {
      height: window.innerHeight,
    };
  },
  components: {
    rotaion,
    bottom,
    Map,
  },
};
</script>

<style scoped>
.center {
  background-color: #ffffff;
  width: 100%;
  padding: 20px 0;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  text-align: left;
}
.cooperation {
  flex-basis: 60%;
  padding-bottom: 35px;
}
.posization {
  flex-basis: 60%;
}
.contact {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  flex-wrap: nowrap;
  line-height: 100px;
}
h2 {
  width: -webkit-fit-content;
  max-width: 200px;
  padding: 10px 20px;
  border-bottom: 3px solid #0086fb;
  margin-bottom: 15px;
}
p {
  width: -webkit-fit-content;
  line-height: 30px;
}
.place p {
  padding-left: 15px;
  line-height: 75px;
  font-size: 21px;
}
@media screen and (max-width: 472px) {
  .cooperation {
    flex-basis: 80%;
  }
  .posization {
    flex-basis: 80%;
  }
  h2 {
    font-size: 25px;
  }
  p {
    width: -webkit-fit-content;
    line-height: 22px;
  }
}
.center-content {
  position: absolute;
  top: 70%;
  z-index: 10000000;
  background-color: #ffffff;
  width: 100%;
}
</style>
